
import {
  FLUSH,
  PAUSE,
  PURGE,
  PERSIST,
  REGISTER,
  REHYDRATE,
  persistStore,
} from "redux-persist"
import React from "react"
import { Provider } from "react-redux"
import ReactDOM from "react-dom/client"
import storage from "redux-persist/lib/storage"
import { configureStore } from "@reduxjs/toolkit"
import { BrowserRouter as Router } from "react-router-dom"
import { PersistGate } from "redux-persist/integration/react"
import { encryptTransform } from "redux-persist-transform-encrypt"
import persistCombineReducers from "redux-persist/es/persistCombineReducers"
import { HeroUIProvider, ToastProvider } from "@heroui/react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { CombinedContext } from "./contexts/CombinedContext.jsx"

import App from "./App.jsx"
import "./index.css"
import {
  accountReducer,
  authReducer,
  companyReducer,
  cutReducer,
  FinalizeMemoEntryReducer,
  flrnReducer,
  invoiceEntryReducer,
  itemReducer,
  ledgerReducer,
  memoEntryReducer,
  mixSlitEntryReducer,
  outstandingPayableReducer,
  outstandingReceivableReducer,
  paymentEntryReducer,
  purityReducer,
  receiveEntryReducer,
  shadeReducer,
  shapeReducer,
  sizeReducer,
  stockEntryReducer,
  outstandingBillEntryReducer,
  packetTransferEntryReducer,
  itemGroupEntryReducer,
  itemTypeEntryReducer,
  clientApiSettingReducer,
  roughAllotmentEntryReducer,
  reportTemplateReducer,
  lotMasterReducer,
  journalVoucherReducer
} from "./state/index.jsx"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExclamationCircle, faSquareXmark } from "@fortawesome/free-solid-svg-icons"
import { ModalToastProvider } from "./components/modalToast/ModalToastContext.jsx"

const queryClient = new QueryClient()

const presistConfig = {
  key: "root",
  storage,
  version: 1,
  transforms: [
    encryptTransform({
      secretKey: process.env.REACT_APP_SECRET_KEY,
      onError: function (error) { },
    }),
  ],
}
const persistedReducer = persistCombineReducers(presistConfig, {
  auth: authReducer,
  company: companyReducer,
  item: itemReducer,
  account: accountReducer,
  memoEntry: memoEntryReducer,
  invoiceEntry:invoiceEntryReducer,
  finalizeEntry:FinalizeMemoEntryReducer,
   shape:shapeReducer,
    shade:shadeReducer,
    cut:cutReducer,
    purity:purityReducer,
    size:sizeReducer,
    flrn:flrnReducer,
    stockEntry:stockEntryReducer,
    mixslitEntry:mixSlitEntryReducer,
    receiveEntry:receiveEntryReducer,
    paymentEntry:paymentEntryReducer,
    outstandingReceivable:outstandingReceivableReducer,
    outstandingPayable:outstandingPayableReducer,
    ledger:ledgerReducer,
    outstandingBillEntry:outstandingBillEntryReducer,
    pktTransfer:packetTransferEntryReducer,
    itemGroupEntry:itemGroupEntryReducer,
    itemTypeEntry:itemTypeEntryReducer,
    clientApiSetting:clientApiSettingReducer,
    roughAllotment:roughAllotmentEntryReducer,
    reportTemplate:reportTemplateReducer,
    lotMaster:lotMasterReducer,
    jvEntry:journalVoucherReducer
})

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoreActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})
export const persistor = persistStore(store)

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <React.StrictMode>

    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ModalToastProvider>
        <CombinedContext>
          <Router>
            <HeroUIProvider>
              <ToastProvider placement={"top-center"}
                maxVisibleToasts={"1"}
                toastProps={{
                  radius: "sm",
                  color: "warning",
                  variant: "flat",
                  icon: <FontAwesomeIcon icon={faExclamationCircle} />,
                  closeIcon: <FontAwesomeIcon icon={faSquareXmark} />,
                  shouldShowTimeoutProgress: "true",
                  classNames: {
                    closeButton: "   text-xl absolute right-4 top-1/2 -translate-y-1/2",
                  },
                }}
              />
              <QueryClientProvider client={queryClient}>
                <App />
              </QueryClientProvider>

            </HeroUIProvider>
          </Router>
        </CombinedContext>
        </ModalToastProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
)
